const ui = {
    namespaced: true,
    state: {
        sidebarExpanded: true,
    },
    mutations: {
        setSidebarExpanded: (state, sidebarExpanded) => {
            state.sidebarExpanded = sidebarExpanded
        },

    },
    actions: {
        setSidebarExpanded: ({commit}, sidebarExpanded) => {
            commit('setSidebarExpanded', sidebarExpanded);
        },
    },
    getters: {
        get: state => {
            return state
        },
        getSidebarExpanded: (state) => {
            return state.sidebarExpanded
        },
    }
}

export default ui;
